import { ChartType } from 'common/types/chart';
import { CustomKpi } from 'common/types/customKpi';
import { FilterOptionType, IFilterOption, IFilterOptionGroup } from 'common/types/filters';
import { KPI } from 'common/types/kpi';
import { AIDED_BRAND_AWARENESS, BRAND_PERCEPTION_KPI, UNAIDED_BRAND_AWARENESS } from 'settings/constants';

export const READONLY_FUNNEL_KPIS = [AIDED_BRAND_AWARENESS, UNAIDED_BRAND_AWARENESS];

export const mapKpiOption =
  (chartType: ChartType, selectedKPIFormulas: Record<string, string> | null) =>
  (
    acc: (IFilterOption | IFilterOptionGroup)[],
    { kpi_identifier: value, kpi_label: label, question_options, kpi_formulas }: KPI,
  ): (IFilterOption | IFilterOptionGroup)[] => {
    const isFunnel = chartType === ChartType.FUNNEL;
    const isMatrix = chartType === ChartType.MATRIX;

    // This is used for Matrix chart, because for Matrix chart we want to show Brand Perception as single option, and not positive, neutral and negative
    const skipQuestionOptions = isMatrix && value === BRAND_PERCEPTION_KPI;

    if (question_options && !skipQuestionOptions) {
      const options = question_options.map(({ option_identifier: value, option_label: label }) => ({
        value,
        label,
        type: FilterOptionType.OPTION as const,
      }));

      if (kpi_formulas) {
        const findFormula = kpi_formulas.find(x => x.kpi_identifier === selectedKPIFormulas?.[value]) || kpi_formulas[0];

        options.push({
          value: findFormula.kpi_identifier,
          label: findFormula.kpi_label,
          type: FilterOptionType.OPTION,
        });
      }

      return acc.concat({
        label,
        options: options,
        type: FilterOptionType.GROUP,
      });
    }

    acc.push({
      value,
      label,
      type: FilterOptionType.OPTION,
      readOnly: isFunnel && READONLY_FUNNEL_KPIS.includes(value),
    });

    return acc;
  };

export const CUSTOM_KPIS_GROUP_LABEL = 'Custom KPIs';

// Appended after the standard KPIs. Identifiers travel in kpi_option_identifiers like option identifiers.
export const mapCustomKpiGroup = (customKpis: CustomKpi[]): IFilterOptionGroup => ({
  label: CUSTOM_KPIS_GROUP_LABEL,
  type: FilterOptionType.GROUP,
  options: customKpis.map(({ identifier: value, name: label, available }) => ({
    value,
    label,
    type: FilterOptionType.OPTION,
    unavailable: !available,
  })),
});
